import { render, staticRenderFns } from "./ProductPlate.vue?vue&type=template&id=5cce6bc3&scoped=true&"
import script from "./ProductPlate.vue?vue&type=script&lang=js&"
export * from "./ProductPlate.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlate.vue?vue&type=style&index=0&id=5cce6bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce6bc3",
  null
  
)

export default component.exports